import React from "react";
import BoxImage from "../../images/home/main_section_bullet--blue.svg";
import BCheckImg from "../../images/home/business_check_sm.jpg";
import "./business-analysis.css";

export default function BusinessAnalysis() {
	return (
		<div className="banalyst">
			<div className="main-fields ">
				<div className="field-hd">
					<h2>Business Potential</h2>
					<div className="typeset">
						<div className="header-icon">
							<img src={BoxImage} alt="BoxIcon" />
						</div>
						<div className="header-desc font-text">
							<p>
								Unsere umfassende Auswertung zu den Themen Digitalisierung,
								Organisation und Prozessmanagement ermöglicht Ihnen neue
								Prespektiven, die ein solides Fundament für zukünftige
								Entscheidungen bieten. Weitere Informationen erhalten Sie auf
							</p>
							<a
								className="animated-link"
								href="https://business-potential.com/"
							>
								Business Potential
							</a>
						</div>
					</div>
				</div>
				<div className="field-preview">
					<div className="picture-cards-lg">
						<a
							href="https://business-potential.com/checks/business-check"
							className="picture-cards-lg__card business_check animated-div"
						>
							<span className="picture-cards-lg__card-title ">
								<span className="picture-cards-lg__card-title-wrapper">
									Business Check
								</span>
							</span>
						</a>
						<a
							href="https://business-potential.com/checks/digitality-check"
							className="picture-cards-lg__card digitality_check animated-div"
						>
							<span className="picture-cards-lg__card-title ">
								<span className="picture-cards-lg__card-title-wrapper">
									Digitality Check
								</span>
							</span>
						</a>
					</div>
				</div>
			</div>
		</div>
	);
}
